import { INSTALLATION_TIMES, MOULIN_COORDS } from './constants';

export const normalizeAddress = (address) => {
  if (!address) return '';
  return address.toLowerCase().trim();
};

export const getInstallationTime = (delivery) => {
  if (!delivery.prestation_type) return 15; // Temps par défaut

  switch (delivery.prestation_type) {
    case 'breakfast':
      if (delivery.person < INSTALLATION_TIMES.PDJ.SMALL.maxPeople) return INSTALLATION_TIMES.PDJ.SMALL.time;
      if (delivery.person < INSTALLATION_TIMES.PDJ.MEDIUM.maxPeople) return INSTALLATION_TIMES.PDJ.MEDIUM.time;
      return INSTALLATION_TIMES.PDJ.LARGE.time;
    case 'mealtray':
      return INSTALLATION_TIMES.PLATEAU_REPAS.time;
    case 'caterer':
      if (delivery?.info?.hasInstallation) return INSTALLATION_TIMES.TRAITEUR_AVEC_INSTALLATION.time;
      return INSTALLATION_TIMES.TRAITEUR_SANS_INSTALLATION.time;
    default:
      return 15; // Temps par défaut
  }
};

export const calculateRouteDistance = async (deliveriesList, directionsService, calculateRouteInfo) => {
  if (!directionsService || !deliveriesList || deliveriesList.length < 1) {
    return { distance: 0 };
  }

  try {
    let totalDistance = 0;
    let currentPoint = MOULIN_COORDS;

    // Calculer la distance pour chaque segment
    for (const delivery of deliveriesList) {
      const { distance } = await calculateRouteInfo(
        currentPoint,
        { lat: delivery.lat, lng: delivery.lng }
      );
      totalDistance += distance;
      currentPoint = { lat: delivery.lat, lng: delivery.lng };
    }

    // Ajouter la distance de retour au Moulin
    const { distance: returnDistance } = await calculateRouteInfo(
      currentPoint,
      MOULIN_COORDS
    );

    console.log('Distance avant retour au Moulin:', totalDistance);
    console.log('Distance de retour au Moulin:', returnDistance);
    totalDistance += returnDistance;
    console.log('Distance totale:', totalDistance);

    return { distance: Math.round(totalDistance) }; // Distance en mètres
  } catch (error) {
    console.error('Erreur lors du calcul de la distance:', error);
    return { distance: 0 };
  }
};
